import { computed } from 'vue';
import { getSuperAdminStatus, getUserRoles } from '@/config/admin';

/**
 * 当前用户信息 composable
 *
 * 提供当前用户的超级管理员状态
 *
 * 注意：不再提供 currentUserId 和 currentTenantId
 * - 所有权限判断应由后端完成
 * - 前端不应解析 JWT 以避免信息暴露风险
 * - 如需用户身份信息，应由后端 API 返回
 */
export function useCurrentUser() {
    /**
     * 判断当前用户是否是超级管理员
     * 从缓存的权限状态中读取（响应式）
     */
    const isSuperAdminUser = computed(() => {
        // 使用响应式的权限状态
        const status = getSuperAdminStatus();
        return status.value === true;
    });

    const isSalesAdminUser = computed(() => {
        const status = getSuperAdminStatus();
        const roles = getUserRoles();
        return status.value === true || roles.value.includes('sales');
    });

    return {
        isSuperAdminUser,
        isSalesAdminUser,
    };
}
